import { classNames } from "@/react/helpers/twMergeWithCN";
import type { TopContributor } from "../../types";
import { t } from "@/i18n-js/instance";
import isEmpty from "lodash/isEmpty";
const i18nRoot = "eoy_recap_2025.sections.members";

interface ContributorAvatarStackProps {
  contributors: TopContributor[];
}

export const ContributorAvatarStack = ({
  contributors,
}: ContributorAvatarStackProps) => {
  if (isEmpty(contributors)) return null;
  return (
    <div className="flex flex-1 items-center justify-center">
      {contributors.map((contributor, index) => (
        <div
          key={contributor.user_avatar_url || `top-contributor-${index}`}
          className={classNames(
            "relative",
            index === 1 ? "size-32 z-20" : "size-24 z-10",
            index > 0 && "-ml-6",
          )}
        >
          <img
            src={contributor.user_avatar_url || "/placeholder.svg"}
            className={classNames(
              "size-full rounded-full object-cover ring-4 ring-[#54139D]",
            )}
            loading="lazy"
            alt={t([
              i18nRoot,
              "bento_items.top_contributor_or_most_active_member",
            ])}
          />
        </div>
      ))}
    </div>
  );
};
